import { existy } from '../../modules/shared/functional';
import { closeModal } from '../modal/modalActions';
import { Utils } from '../../common';
import LoginApi from '../api/LoginApi';

export function loggingIn() {
  return {
    type: 'LOGGING_IN',
  };
}

export function logInFailure(error) {
  return {
    type: 'LOGIN_FAILURE',
    value: error,
  };
}

function ObjectException(value) {
  this.value = value;
}


export function loginSuccess() {
  return {
    type: 'LOGIN_SUCCESS',
  };
}

export function logOut() {
  return {
    type: 'LOGOUT',
  };
}

export function loginStatusChange(isLoggedIn) {
  return {
    type: 'LOGIN_STATUS_CHANGE',
    isLoggedIn,
  };
}

export function logIn(values, onSigninSuccess) {
  return (dispatch, getState) => {
    dispatch(loggingIn());
    return LoginApi.login(values['login-email'], values['login-password'])
      .then((response) => {
        const resp = response.data;
        if (resp.error) {
          dispatch(logInFailure(resp.error));
          throw new ObjectException(JSON.parse(resp.error));
        }

        const state = getState();

        window.digitalData.user.profile.authenticationStatus = 'consumer';
        window.digitalData.user.profile.profileInfo =
          window.digitalData.user.profile.profileInfo || {};
        window.digitalData.user.profile.profileInfo.profileID = resp;

        const thdAnalyticsEvent = {
          category: {
            primaryCategory: 'button submission',
          },
          eventInfo: {
            eventName: 'sign in success',
          },
        };

        // publish the event triggering *modal* login
        if (existy(state.modal.event)) {
          const loginCompletedEvent =
          new CustomEvent('loginCompleted', { detail: state.modal.event.detail });
          document.dispatchEvent(loginCompletedEvent);

          const mergedDetail = Object.assign({}, state.modal.event.detail, { taskName: 'loginStatusChange', isLoggedIn: true });
          const loginStatusChangeEvent =
          new CustomEvent('loginStatusChange', { detail: mergedDetail });
          document.dispatchEvent(loginStatusChangeEvent);
          dispatch(loginSuccess());
          dispatch(closeModal());
          Utils.sendAnalyticsEvent(thdAnalyticsEvent, 0).then(() => {
            onSigninSuccess();
          });
        } else {
          Utils.sendAnalyticsEvent(thdAnalyticsEvent).then(() => {
            onSigninSuccess();
          });
        }
      })
      .catch((exception) => {
        dispatch(logInFailure(exception.value.error));
      });
  };
}
